<template>
  <v-sheet height="100%" color="transparent">
    <div v-if="authorId">
      <author :item-id="authorId" />

      <v-container v-if="items.length">
        <div class="vinheta">
          <div
            class="d-flex align-center font-weight-regular white--text small"
          >
            <v-icon class="mr-3"> fa fa-play </v-icon>
            Projetos
          </div>

          <div class="font-weight-black white--text text-uppercase mt-4 big">
            QUE PARTICIPOU
          </div>
        </div>
      </v-container>
    </div>

    <div class="primary darken-4" v-if="!loading">
      <portfolio :items="items" v-if="items.length" />
    </div>
    <v-sheet
      v-else
      class="d-flex justify-center align-center"
      height="100%"
      width="100%"
      color="transparent"
    >
      <v-progress-circular
        :size="50"
        color="white"
        indeterminate
      ></v-progress-circular>
    </v-sheet>
  </v-sheet>
</template>

<script>
import Portfolio from "../../widgets/Portfolio.vue";
import Author from "../../widgets/Author.vue";
import { formatToURL } from "../../utils";

export default {
  data: () => ({
    loading: true,
    bottom: false,
    items: [],
    page: 1,
    itemsPerPage: 10,
    totalItems: 0,
    authorId: "",
  }),
  computed: {
    pagesLength() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
  },
  created() {
    window.addEventListener("scroll", () => {
      this.bottom = this.bottomVisible();
    });

    this.loading = true;

    this.get();
  },
  watch: {
    bottom(bottom) {
      if (bottom && this.totalItems > this.items.length) {
        this.page += 1;
        this.get();
      }
    },
    $route() {
      this.totalItems = 0;
      this.get();
    },
  },
  methods: {
    bottomVisible() {
      const scrollY = window.scrollY;
      const visible = document.documentElement.clientHeight;
      const pageHeight = document.documentElement.scrollHeight - 400;
      const bottomOfPage = visible + scrollY >= pageHeight;
      return bottomOfPage || pageHeight < visible;
    },
    get() {
      const params = {
        itemsPerPage: this.itemsPerPage,
        returnTotalItems: 1,
        page: this.page,
      };

      this.authorId =
        this.$route.path !== "/portfolio" && this.$route.params.item
          ? parseFloat(this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1"))
          : "";

      if (this.authorId) params.author = this.authorId;

      this.$rest("portfolio")
        .get({
          params,
          keepCache: true,
          save: (state, { totalItems, list }) => {
            list = list.map(
              ({
                id,
                img_cover_desktop,
                img_cover_mobile,
                title,
                subtitle,
              }) => ({
                img_cover_desktop,
                img_cover_mobile,
                title,
                subtitle,
                to: `/portfolio/${formatToURL(title)}-${id}`,
              })
            );

            if (this.totalItems === 0) this.items = list;
            else this.items = [...this.items, ...list];
            // else this.items = this.items.concat(list);

            this.totalItems = totalItems;
          },
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
  components: {
    Portfolio,
    Author,
  },
};
</script>
<style scoped>
.vinheta .small {
  font-size: 21px;
  line-height: 24px;
}

.vinheta .small .v-icon {
  background: rgb(237, 50, 55);
  background: -moz-linear-gradient(
    0deg,
    rgba(243, 116, 53, 1) 0%,
    rgba(237, 50, 55, 1) 100%
  );
  background: -webkit-linear-gradient(
    0deg,
    rgba(243, 116, 53, 1) 0%,
    rgba(237, 50, 55, 1) 100%
  );
  background: linear-gradient(
    0deg,
    rgba(243, 116, 53, 1) 0%,
    rgba(237, 50, 55, 1) 100%
  );
  background-clip: text;
  -o-background-clip: text;
  -moz-background-clip: text;
  -webkit-background-clip: text;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#f37435",endColorstr="#ed3237",GradientType=1);
  font-size: 24px;
  margin-top: -2px;
  text-fill-color: transparent;
  -o-text-fill-color: transparent;
  -moz-text-fill-color: transparent;
  -webkit-text-fill-color: transparent;
  transform: rotate(-90deg);
}

.vinheta .big {
  font-size: 28px;
}
</style>
